export const breadCrumbTestId = "breadcrumb";
export const sidebarLayoutMenuTestId = "sidebarLayoutMenu";
export const sidebarLayoutContentTestId = "sidebarLayoutContent";
export const iconButtonTestId = "iconbutton";
